import React from "react";
import { Siren, Phone } from "lucide-react";
import { COMPANY } from "@/data/site";

export default function EmergencyBanner() {
  return (
    <div
      data-testid="emergency-banner"
      className="bg-[#DC2626] text-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center">
        <div className="flex items-center gap-2 emergency-pulse">
          <Siren className="h-4 w-4" strokeWidth={2} />
          <span className="text-xs sm:text-sm font-semibold tracking-wide">
            24/7 Emergency Plumbing — Weekend Service Available
          </span>
        </div>
        <a
          href={`tel:${COMPANY.phoneTel}`}
          data-testid="emergency-banner-call-link"
          className="inline-flex items-center gap-1 text-xs sm:text-sm font-bold underline underline-offset-4 hover:opacity-90"
        >
          <Phone className="h-3.5 w-3.5" strokeWidth={2} />
          {COMPANY.phone}
        </a>
      </div>
    </div>
  );
}
